import { render, staticRenderFns } from "./AddPlayer.vue?vue&type=template&id=36bcb188&"
import script from "./AddPlayer.vue?vue&type=script&lang=js&"
export * from "./AddPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AddPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports